import { isEmpty } from 'ramda';
import { GroupLookup } from '~/components/ToggleAccordion';
import {
  AppConfigurationFragment,
  WidgetSettingsAppConfiguration__Input,
  WidgetSettingsPinned,
  WidgetSettingsPinned__Input,
} from '~/graphql/types';
import { PinnedAppsMap } from '../../states/pinnedApps';
import indexToWeight from '../indexToWeight';

/**
 * returns appGroupsLookup in a shape for widget settings apps configuration input
 * @param {GroupLookup} appGroupsLookup
 * @param {Array<AppsConfigurationFragment>} appsConfiguration
 */

const serializePinnedFields = (
  pinned?: WidgetSettingsPinned,
): WidgetSettingsPinned__Input | undefined => {
  if (!pinned) return;
  const serializedWeight = indexToWeight(pinned.weight);
  return { enabled: pinned.enabled, weight: serializedWeight };
};
const getAppsConfigurationInput = (
  pinnedApps: PinnedAppsMap,
  appGroupsLookup: GroupLookup,
  appsConfiguration: Array<AppConfigurationFragment>,
): Array<WidgetSettingsAppConfiguration__Input> => {
  if (appsConfiguration.length === 0 || isEmpty(appGroupsLookup)) return [];

  const appsConfigurationInput: Array<WidgetSettingsAppConfiguration__Input> =
    [];

  for (const key in appGroupsLookup) {
    const { mainChecked, items } = appGroupsLookup[key];

    appsConfigurationInput.push({
      type: key,
      visible: mainChecked,
      pinned: serializePinnedFields(pinnedApps[key]),
      items: items
        ? items.map(item => ({
            id: item.id,
            visible: item.checked,
            pinned: serializePinnedFields(pinnedApps[item.id]),
          }))
        : [],
    });
  }

  return appsConfigurationInput;
};
export default getAppsConfigurationInput;
